module.exports = __webpack_public_path__ + "static/media/arrow-down.716a66f1.svg";